import { render, staticRenderFns } from "./DynamicMessageGroup.vue?vue&type=template&id=6e99e464"
import script from "./DynamicMessageGroup.vue?vue&type=script&lang=ts"
export * from "./DynamicMessageGroup.vue?vue&type=script&lang=ts"
import style0 from "./DynamicMessageGroup.vue?vue&type=style&index=0&id=6e99e464&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports